import EditIcon from "@mui/icons-material/Edit";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import InstagramIcon from "@mui/icons-material/Instagram";
import ReplyIcon from "@mui/icons-material/Reply";
import TwitterIcon from "@mui/icons-material/Twitter";
import {
  Alert,
  AppBar,
  Avatar,
  Box,
  Button,
  Container,
  Grid,
  Hidden,
  Paper,
  Snackbar,
  Tab,
  Tabs,
  Toolbar,
  Typography,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";
import moment from "moment";
import { PropTypes } from "prop-types";
import { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import SwipeableViews from "react-swipeable-views";
//import { baseUrl } from "../../services";
//import "../adminPreferences/AdminPreferences.css";
import { AppDataContext } from "../../../common/appContext";
import { DataGrid } from "@mui/x-data-grid";
import { PlayerProfileService } from "./../../../services/playerProfile.Service";
//import MidRangeStarDrill from "./viewProfileSections/MidRangeStarDrill";
import MidRangeStarDrill from "./MidRangeStarDrill";
import MidSideMidDrill from "./MidSideMidDrill";
import OffTheDribbleShooting from "./OffTheDribbleShooting";
import FreeThrows from "./FreeThrows";
import ShootingDrillsSummary from "./ShootingDrillsSummary";
import SideMidSideDrill from "./SideMidSideDrill";

import SpotUpShooting from "./SpotUpShooting";

import ThreePointStarDrill from "./ThreePointStarDrill";

const useStyles = makeStyles((theme) => ({
  btnselected: {
    backgroundColor: "#C8102E", //"#1d428a",
    color: "#fff",
    marginRight: theme.spacing(1),
    "&:hover": {
      backgroundColor: "#C8102E",
    },
  },
  btnunselected: {
    backgroundColor: "#707070",
    color: "#fff",
    marginRight: theme.spacing(1),
    "&:hover": {
      backgroundColor: "#707070",
    },
  },
}));
export default function ShootingScreen(props) {
  const classes = useStyles();
  const theme = useTheme();
  const { playerID, styles, EventId } = props;
  const [playerYear, setplayerYear] = useState([{}]);
  const { selectedEventId, user } = useContext(AppDataContext);
  const [eventId, setEventId] = useState(selectedEventId);
  const [btn1, setbtn1] = useState(false);
  const [btn2, setbtn2] = useState(false);
  const [btn3, setbtn3] = useState(false);
  const [btn4, setbtn4] = useState(false);
  const [btn5, setbtn5] = useState(false);
  const [columnFlex, setColumnFlex] = useState(
    window.innerWidth >= 768 ? 1 : "none"
  );
  useEffect(() => {
    setEventId(selectedEventId);
    setbtn1(false);
    setbtn2(false);
    setbtn3(false);
    setbtn4(false);
    setbtn5(false);
  }, [selectedEventId]);
  useEffect(() => {
    PlayerProfileService.getAnthrosDataByPlayerYear(eventId, playerID).then(
      (response) => {
        //console.log("setCombineYearDropdownData ", response.data);

        setplayerYear(response.data);
        var pdata = response.data;
        pdata.map((item, index) => {
          if (item.eventId === eventId + "" && index == 0) {
            setbtn1(true); //btn1=true;
          } else if (item.eventId === eventId + "" && index == 1) {
            setbtn2(true); // btn2=true;
          } else if (item.eventId === eventId && index == 2) {
            setbtn3(true); // btn2=true;
          } else if (item.eventId === eventId && index == 3) {
            setbtn4(true); //btn4=true;
          } else if (item.eventId === eventId && index == 4) {
            setbtn5(true); // btn5=true;
          }
        });
      }
    );

    window.addEventListener("resize", onResize);
    return () => {
      window.removeEventListener("resize", onResize);
    };
  }, [eventId]);
  const onResize = () => {
    setColumnFlex(window.innerWidth >= 768 ? 1 : "none");
  };
  const getyearValue = (playerEventId, index) => {
    if (index === 0) {
      setbtn1(true);
      setbtn2(false);
      setbtn3(false);
      setbtn4(false);
      setbtn5(false);
      //  btn1=true;btn2=false;btn3=false;btn4=false;btn5=false;
    } else if (index === 1) {
      setbtn1(false);
      setbtn2(true);
      setbtn3(false);
      setbtn4(false);
      setbtn5(false); //btn1=false;btn2=true;btn3=false;btn4=false;btn5=false;
    } else if (index === 2) {
      setbtn1(false);
      setbtn2(false);
      setbtn3(true);
      setbtn4(false);
      setbtn5(false); //btn1=false;btn2=false;btn3=true;btn4=false;btn5=false;
    } else if (index === 3) {
      setbtn1(false);
      setbtn2(false);
      setbtn3(false);
      setbtn4(true);
      setbtn5(false); //btn1=false;btn2=false;btn3=false;btn4=true;btn5=false;
    } else if (index === 4) {
      setbtn1(false);
      setbtn2(false);
      setbtn3(false);
      setbtn4(false);
      setbtn5(true); // btn1=false;btn2=false;btn3=false;btn4=false;btn5=true;
    }

    setEventId(playerEventId);
  };

  return (
    <>
      <Box
        display="flex"
        alignItems={"center"}
        justifyContent="center"
        mt={1}
        mb={1}
      >
        {playerYear.length > 1
          ? playerYear.map((item, index) => {
              if (index === 0) {
                return (
                  <>
                    <Typography
                      variant="h6"
                      fontStyle="italic"
                      mr={2}
                      color={"primary"}
                    >
                      Details available for{" "}
                    </Typography>
                    <Button
                      onClick={() => getyearValue(item.eventId, index)}
                      key={index}
                      className={
                        btn1 === true
                          ? classes.btnselected
                          : classes.btnunselected
                      }
                    >
                      Year {item.eventYear}
                    </Button>
                  </>
                );
              } else if (index === 1) {
                return (
                  <Button
                    onClick={() => getyearValue(item.eventId, index)}
                    key={index}
                    className={
                      btn2 === true
                        ? classes.btnselected
                        : classes.btnunselected
                    }
                  >
                    Year {item.eventYear}
                  </Button>
                );
              } else if (index === 2) {
                return (
                  <Button
                    onClick={() => getyearValue(item.eventId, index)}
                    key={index}
                    className={
                      btn3 === true
                        ? classes.btnselected
                        : classes.btndeselected
                    }
                  >
                    Year {item.eventYear}
                  </Button>
                );
              } else if (index === 3) {
                return (
                  <Button
                    onClick={() => getyearValue(item.eventId, index)}
                    key={index}
                    className={
                      btn4 === true
                        ? classes.btnselected
                        : classes.btnunselected
                    }
                  >
                    Year {item.eventYear}
                  </Button>
                );
              } else if (index === 4) {
                return (
                  <Button
                    onClick={() => getyearValue(item.eventId, index)}
                    key={index}
                    className={
                      btn5 === true
                        ? classes.btnselected
                        : classes.btnunselected
                    }
                  >
                    Year {item.eventYear}
                  </Button>
                );
              } else {
                return (
                  <Button
                    onClick={() => getyearValue(item.eventId, index)}
                    key={index}
                    className={
                      btn5 === true
                        ? classes.btnselected
                        : classes.btnunselected
                    }
                  >
                    {item.eventYear}
                  </Button>
                );
              }
            })
          : ""}
      </Box>

      <ShootingDrillsSummary
        EventId={eventId}
        playerID={playerID}
        styles={styles}
      />
      <SpotUpShooting EventId={eventId} playerID={playerID} styles={styles} />
      <ThreePointStarDrill
        EventId={eventId}
        playerID={playerID}
        styles={styles}
      />
      <MidRangeStarDrill
        EventId={eventId}
        playerID={playerID}
        styles={styles}
      />
      <SideMidSideDrill EventId={eventId} playerID={playerID} styles={styles} />
      <MidSideMidDrill EventId={eventId} playerID={playerID} styles={styles} />
      <OffTheDribbleShooting
        EventId={eventId}
        playerID={playerID}
        styles={styles}
      />
      <FreeThrows EventId={eventId} playerID={playerID} styles={styles} />
    </>
  );
}
